import styled from 'styled-components';

export default styled.button`
  background-color: transparent;
  border: none;
  width: 30px;
  height: 30px;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.7;
  border-radius: 2px;

  /* &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  } */
`;



// WEBPACK FOOTER //
// ./src/controller/components/SmallButton.ts